export default __webpack_public_path__ + "static/media/self-service-hero.min.0e71fad3.svg";